export const SCROLL_EASE = 0.15;
export const PARALLAX_IMAGE_EASE = 0.4;
export const DEFAULT_PARALLAX_IMAGE_MULTIPLIER = 0.2;
